import {
  PublicClientApplication,
  CacheLookupPolicy,
  Configuration,
  LogLevel,
} from '@azure/msal-browser'

const _required = {
  VITE_AZURE_TENANT_ID: import.meta.env.VITE_AZURE_TENANT_ID,
  VITE_AZURE_CLIENT_ID: import.meta.env.VITE_AZURE_CLIENT_ID,
  VITE_AZURE_BACKEND_CLIENT_ID: import.meta.env.VITE_AZURE_BACKEND_CLIENT_ID,
  VITE_REDIRECT_URI: import.meta.env.VITE_REDIRECT_URI,
} as const

const _missing = (Object.keys(_required) as Array<keyof typeof _required>).filter(
  (k) => !_required[k],
)
if (_missing.length > 0) {
  throw new Error(
    `Faltan variables de entorno requeridas: ${_missing.join(', ')}. ` +
    'Revisa tu archivo .env.local',
  )
}

const tenantId = _required.VITE_AZURE_TENANT_ID
const clientId = _required.VITE_AZURE_CLIENT_ID
const backendClientId = _required.VITE_AZURE_BACKEND_CLIENT_ID
const redirectUri = _required.VITE_REDIRECT_URI

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    // localStorage: la sesión se comparte entre pestañas y sobrevive al
    // reinicio del navegador (SSO estándar). Antes era sessionStorage, que la
    // aislaba por pestaña y obligaba a re-loguear en cada una.
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return
        if (level === LogLevel.Error) console.error(message)
        else if (level === LogLevel.Warning) console.warn(message)
      },
      logLevel: LogLevel.Warning,
    },
  },
}

export const loginRequest = {
  scopes: [`api://${backendClientId}/Proveedores.Access`],
}

// Token de las llamadas a la API: del cache o con el refresh token, nunca con el
// iframe oculto. La CSP del sitio (frame-ancestors 'none') bloquea ese iframe y
// MSAL esperaba 10 s para fallar con un error que no pide login, así que la
// llamada salía sin token (401 y "Tu cuenta no tiene un rol asignado"). Cuando el
// refresh token caduca (24 h en una SPA), así falla con
// InteractionRequiredAuthError y la app redirige al login.
export const tokenRequest = {
  ...loginRequest,
  cacheLookupPolicy: CacheLookupPolicy.AccessTokenAndRefreshToken,
}

export const msalInstance = new PublicClientApplication(msalConfig)
